import React, { useEffect } from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  Collapse,
  Button,
  Table,
  Card,
  Col,
  Form,
  Row,
  Accordion,
} from "react-bootstrap";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, formatStringKey } from "../../constant/_constant";
import moment from "moment";
import { IconHistory, IconTriangle } from "@tabler/icons-react";
import Lottie from "lottie-react";
import notfoundData from "../../assets/not_found.json";
import { formatToTitleCase } from "../../utils/_helpers";

function GetOrderHistoryDialog({ show, setShow, orderSku }) {
  const { postData: fetchORDER_HISTORY, data } = usePostRequest(
    API_ENDPOINTS.GET_ORDER_REVISION_HISTORY
  );

  const [openRows, setOpenRows] = useState({});
  const handleToggle = (index) => {
    setOpenRows((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const payloadData = {
    order_id: orderSku,
  };

  useEffect(() => {
    fetchORDER_HISTORY(payloadData);
  }, [orderSku]);

  return (
    <Modal
      show={show}
      scrollable={true}
      onHide={() => setShow({ show: false })}
      // className="skusearch"
      dialogClassName="modal-90w"
      size="lg"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="gap-2 align-items-center" closeButton>
        <span className="avatar bg-lime-lt rounded-circle">
          <IconTriangle />
        </span>
        <div>
          <Modal.Title>Order Update History (Non-SKU Changes) </Modal.Title>
          <Card.Subtitle>
            Order ID: <strong>{orderSku}</strong>
          </Card.Subtitle>
        </div>
      </Modal.Header>
      <Modal.Body className="pe-0 ps-0 pb-0">
        {data && data.data && data.data.length > 0 ? (
          data.data.map((item, index) => (
            <div className="rfq_box_item" key={index}>
              <Accordion>
                <Accordion.Item eventKey="1">
                  <Accordion.Header className="accordian_items">
                    {item.User.username}{" "}
                    {moment(item.updated_at).format("MM/DD/YYYY HH:mm")}
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="mail_wrapper p-0 border-0 mb-0">
                      <div className="table-responsive">
                        <Table bordered>
                          <thead>
                            <tr>
                              <th>Field</th>
                              <th>Old Value</th>
                              <th>New Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.changes_json.map((changeItem, idx) => {
                              let change = changeItem.changes;
                              return Object.keys(change).map((key, idx2) => {
                                const fieldChange = change[key];

                                //  other_cost
                                if (key === "other_cost") {
                                  return (
                                    <>
                                      {fieldChange.added &&
                                        fieldChange.added.length > 0 &&
                                        fieldChange.added.map(
                                          (addedItem, addedIdx) => (
                                            <tr key={`added-${addedIdx}`}>
                                              <td>
                                                {`Other Cost: ${formatStringKey(
                                                  addedItem.Name
                                                )}`}{" "}
                                                <span
                                                  className="blinking-text"
                                                  style={{
                                                    color: "green",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  New
                                                </span>
                                              </td>
                                              <td>{"N/A"}</td>
                                              <td>
                                                {" "}
                                                {addedItem.Amount ||
                                                  "N/A"}{" "}
                                              </td>
                                            </tr>
                                          )
                                        )}

                                      {fieldChange.removed &&
                                        fieldChange.removed.length > 0 &&
                                        fieldChange.removed.map(
                                          (removedItem, removedIdx) => (
                                            <tr
                                              style={{
                                                textDecoration: "line-through",
                                                color: "red",
                                                marginRight: "5px",
                                              }}
                                              key={`removed-${removedIdx}`}
                                            >
                                              <td
                                                style={{ color: "red" }}
                                              >{`Other Cost: ${formatStringKey(
                                                removedItem.Name
                                              )}`}</td>
                                              <td style={{ color: "red" }}>
                                                {removedItem.Amount || "N/A"}
                                              </td>
                                              <td style={{ color: "red" }}>
                                                {"N/A"}
                                              </td>
                                            </tr>
                                          )
                                        )}

                                      {fieldChange.modified &&
                                        fieldChange.modified.length > 0 &&
                                        fieldChange.modified.map(
                                          (modifiedItem, modifiedIdx) => (
                                            <tr key={`modified-${modifiedIdx}`}>
                                              <td>{`Other Cost: ${formatStringKey(
                                                modifiedItem.Name
                                              )}`}</td>
                                              <td>
                                                {modifiedItem.old_amount || "N/A"}
                                              </td>
                                              <td>
                                                {modifiedItem.new_amount || "N/A"}
                                              </td>
                                            </tr>
                                          )
                                        )}
                                    </>
                                  );
                                } else {
                                  return (
                                    <tr key={`${idx}-${idx2}`}>
                                      <td>{formatStringKey(key)}</td>
                                      <td>{fieldChange.old || "N/A"}</td>
                                      <td>{fieldChange.new || "N/A"}</td>
                                    </tr>
                                  );
                                }
                              });
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          ))
        ) : (
          <div className="data_not_available text-center pb-4">
            {" "}
            <Lottie animationData={notfoundData} />{" "}
            <p>No Opportunity history Available For this Quote.</p>{" "}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default GetOrderHistoryDialog;
